import React from 'react';
export function Header() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className="sticky top-0 z-40 w-full backdrop-blur-md bg-brand-black/80 border-b border-white/5" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-60">
        <div className="flex items-center gap-2" data-id="element-61">
          <span className="font-serif text-xl font-bold tracking-wider text-white" data-id="element-62">
            AURA BIT
          </span>
        </div>
        <a href="#pricing" onClick={scrollToPricing} className="hidden sm:inline-flex items-center justify-center px-6 py-2 text-sm font-medium text-brand-black bg-brand-pink rounded-full hover:bg-brand-pink-deep transition-colors duration-200" data-id="element-63">
          Quiero el Megapack
        </a>
      </div>
    </header>;
}